import { html } from 'lit-element';
import { until } from 'lit-html/directives/until';
import { culture } from '../intl';

const API_URL_BASE = '/api/translations';

class Resource {
	constructor(key) {
		this.key = key;
		this.isFetched = false;

		this.labels = fetch(`${API_URL_BASE}/${this.key}/${culture}`).then(res => res.json());
	}

	async getLabel(key) {
		const labels = await this.labels;

		return labels[key];
	}
}

const resources = new Map();

const getTranslation = async (resourceName, labelKey, fallback) => {
	if (!resources.has(resourceName)) {
		resources.set(resourceName, new Resource(resourceName));
	}

	const resourceInstance = resources.get(resourceName);

	try {
		const label = await resourceInstance.getLabel(labelKey);

		if (label) {
			return label;
		}

		console.warn(`label ${labelKey} not found`);

		return fallback;
	} catch (e) {
		console.warn(`There was an error fetching resource ${resourceName}`);

		return fallback;
	}
};

const translate = (resource, label, fallback) => until(getTranslation(resource, label, fallback), html`${fallback}`);

export default translate;
export { getTranslation };
